import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalDetails extends Component{
	constructor(props){
		super(props);
		
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show:false,
			date:"",
			hour:"",
			parts:[],
			number_target:"",
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'cryoprecipitate_process/'+id,{
			methid:'get',
			headers:new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					show:true,
					date:moment(response.date).format('DD/MM/YYYY'),
					parts:response.parts
				});
			}
		});
	}

	handleClose(){
		this.setState({
			show:false
		});
	}

	render(){
		const {t} = this.props;

		return (
			<Modal  show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles Alicuotas</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 form-group">
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Fecha</span>
		        				<input type="text" name="date" id="date"
		        					value={this.state.date} disabled
		        					className="form-control" />
		        			</div>
		        		</div>
		        		<div className="col-xs-12">
	        				<Table responsive hover>
	        					<thead>
		        					<tr>
		        						<th>Componente</th>
		        						<th>Volumen (ml)</th>
		        					</tr>
	        					</thead>
	        					<tbody>
	        						{this.state.parts.map((part, i)=>(
	        							<tr key={i}>
	        								<td>{part.component}</td>
	        								<td>{part.volume+' ml'}</td>
	        								
	        							</tr>
		        							
	        						))}
	        					</tbody>
	        				</Table>
	        			</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>
		)
	}

}
export default translate('translations')(ModalDetails)